import pick from 'lodash/pick';

import {isAnonymous, isSubscriber} from 'topmeteo/utils/html';
import {createReducer} from 'topmeteo/utils/redux';

import {
    Animation,
    Data,
    Date,
    Environment,
    History,
    Index,
    Product,
    Resolution,
    Request,
    Settings,
    Timer,
} from '../actions';

import region from './region';
import shopPopUp from './shopPopUp';

export const initialState = {

    /* Static Store */
    timezone: null,
    language: null,
    CSRFMiddlewareToken: null,
    NoAutoReload: AutoReload === false,
    isAnonymous,
    isSubscriber,

    /* Environment Store */
    canPreload: false,

    ...region.initialState,

    /* Interests Store */
    interests: [],
    resetFavouritesURL: null,

    /* Product Store */
    categories: [],
    products: {},
    productID: null,
    resolution: 120,
    request: null,
    timer: null,
    reloadURL: null,
    toggleFavouriteURL: null,
    showProductLegend: false,

    /* Indices Store */
    indices: [],
    index: null,

    /* Date Store */
    dates: [],
    offset: null,

    /* Settings Store */
    showMatrix: true,
    showFavouritesOnly: true,
    favoritesResetURL: null,
    userDefaultsURL: null,

    /* Animation Store */
    panelOpen: false,
    isDragging: null,
    isAnimating: false,
    animationSpeed: 50,
    animationStart: 0,
    animationStop: 23,

    ...shopPopUp.initialState,

};

const UpdateValues = [
    'categories',
    'dates',
    'indices',
    'interests',
    'products',
    'regions',
    'resolution',
    'timezone',
    'gridpoint',
    'position',
];

export const reducers = {
    ...region.reducers,
    ...shopPopUp.reducers,
    [Product.change]: (state, productID) => ({productID, isAnimating: false, canPreload: false}),
    [Product.legend]: (state, showProductLegend) => ({showProductLegend}),
    [Index.change]: (state, index) => ({index, isAnimating: false}),
    [Date.change]: (state, offset) => ({offset, isAnimating: false, canPreload: false}),
    [Resolution.change]: (state, resolution) => ({resolution}),
    [Settings.showMatrix]: (state, showMatrix) => ({showMatrix}),
    [Settings.showFavouritesOnly]: (state, showFavouritesOnly) => ({showFavouritesOnly}),
    [Data.reloaded]: (state, {isInitial, ...data}) => isInitial ? data : pick(data, UpdateValues),
    [History.popState]: (state, data) => data,
    [Timer.started]: (state, timer) => ({timer}),
    [Timer.cancelled]: () => ({timer: null}),
    [Request.started]: (state, request) => ({request}),
    [Request.failed]: () => ({request: null}),
    [Request.succeeded]: () => ({request: null}),
    [Request.cancelled]: () => ({request: null}),
    [Animation.start]: () => ({isAnimating: true}),
    [Animation.stop]: () => ({isAnimating: false}),
    [Animation.speed]: (state, animationSpeed) => ({animationSpeed}),
    [Animation.panel]: (state, panelOpen) => ({panelOpen}),
    [Animation.startIndex]: ({animationStop}, animationStart) => ({
        animationStart: animationStart < animationStop ? animationStart : animationStop - 1,
    }),
    [Animation.stopIndex]: ({animationStart}, animationStop) => ({
        animationStop: animationStop > animationStart ? animationStop : animationStart + 1,
    }),
    [Animation.index]: (state, index) => ({index}),
    [Environment.dragging]: (state, isDragging) => ({isDragging}),
    [Product.setFavourite]: ({products}, {productID, isFavourite}) => {
        const product = products[productID];

        return {
            products: {
                ...products,
                [productID]: {
                    ...product,
                    isFavourite,
                },
            },
        };
    },
    [Environment.canPreload]: (state, canPreload) => ({canPreload}),
};

export default createReducer(initialState, reducers);
